import { TranslationContext } from 'contexts/translation-context';

import { useContext } from 'react';
import styled from 'styled-components';

const FirstText = styled.div`
  font-family: ${props => props.theme.fonts.montserratMedium};
  color: ${props => props.theme.colors.siteBlack};
  font-size: 20px;
  text-align: center;
  margin-bottom: 16px;
`;
const SecondText = styled.div`
  font-family: ${props => props.theme.fonts.montserratLight};
  color: ${props => props.theme.colors.siteBlack};
  font-size: 12px;
  text-align: center;
  white-space: break-spaces;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${props => props.theme.colors.white};
  align-items: center;
`;

export const PaymentErrorModal = () => {
  const TRANSLATION_TEXT = useContext(TranslationContext) as { [key: string]: string };
  return (
    <Container>
      <FirstText>{TRANSLATION_TEXT.we_were_unable_to_process_your_credit_card}</FirstText>
      <SecondText>{TRANSLATION_TEXT.please_double_check_your_payment_information_first}</SecondText>
      <SecondText>
        {TRANSLATION_TEXT.please_double_check_your_payment_information_second}
      </SecondText>
    </Container>
  );
};
